import { State } from '@ispm-client/modules/bpmn-modeler/store/state';
import { createSelector, MemoizedSelector } from '@ngrx/store';
import { selectBpmnModelerState } from '@ispm-client/modules/bpmn-modeler/store/selectors/bpmn-modeler-state.selector';

/**
 * Created By Elia Rohana on 2/12/19
 */
const getLastNodeId = (state: State): number => state.lastNodeId;

export const selectLastNodeId: MemoizedSelector<object, number> = createSelector(selectBpmnModelerState, getLastNodeId);

